import { Link, useLocation } from 'react-router-dom';
import { useGiveaway } from './GiveawayProvider';

export default function GiveawayHubButton() {
    const { collectedTokenAnimation } = useGiveaway();
    const location = useLocation();

    if (location.pathname.startsWith('/giveaway')) return null;

    return (
        <>
            <Link
                to="/giveaway"
                className="bjnt-giveaway-hub"
                aria-label="Open giveaway page"
            >
                <span className="bjnt-giveaway-hub__icon">🎁</span>
                <span className="bjnt-giveaway-hub__label">Win</span>
            </Link>

            {collectedTokenAnimation ? (
                <div className="bjnt-giveaway-fly-token">
                    {collectedTokenAnimation.imageUrl ? (
                        <img src={collectedTokenAnimation.imageUrl} alt="" />
                    ) : (
                        <span>{collectedTokenAnimation.name || 'Sticker'}</span>
                    )}
                </div>
            ) : null}
        </>
    );
}